import React, { useEffect, useCallback, useState, ReactNode } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { RemoveScrollBar } from 'react-remove-scroll-bar'
import { VideoPlayer } from '../../../src/components'
import { updateUserProfile } from '../../libs/services'
import { useAuth } from '../../hooks/useAuth'
import config from '../../config/config'

export const Instructions: React.FunctionComponent = () => {
  const DASHBOARD_INSTRUCTIONS_VIDEO = `${config.loadEnvironmentVariables().courseFilesUrl}video/dashboard-instructions.mp4`
  const navigate = useNavigate()
  const { state } = useLocation()
  const [playing, setPlaying] = useState<boolean | undefined>(undefined)
  const [videoFinished, setVideoFinished] = useState<boolean>(false)
  const [currentVideoUrl, setCurrentVideoUrl] = useState<string>(DASHBOARD_INSTRUCTIONS_VIDEO)
  const { userProfile, setUserProfile } = useAuth()

  useEffect(() => {
    if (state?.videoPath !== undefined) {
      setCurrentVideoUrl(state.videoPath)
    }
  }, [state.videoPath])

  const handleVideoEnded = useCallback(async () => {
    setPlaying(false)

    setVideoFinished(true)
    const res = await updateUserProfile({ walkthroughCompleted: true })

    if (res !== null) {
      const updatedProfile = res?.data?.data
      setUserProfile({ ...userProfile, user_profile: updatedProfile })
      navigate(state.returnPath, { state: { profileUpdated: true } })
    }
  }, [setPlaying, setVideoFinished, navigate, setUserProfile, state.returnPath, userProfile])

  const renderVideo: (url: string, autoplay: boolean) => ReactNode = (url: string, autoplay: boolean) => (
    <VideoPlayer
      handleEnded={() => {
        void (async () => {
          await handleVideoEnded()
        })()
      }}
      isPlaying={autoplay ? true : playing}
      muted={autoplay}
      instructionMode
      url={url}
    />
  )

  return (
    <div className={`!bg-cover flex flex-col items-center h-screen ${!videoFinished ? 'p-0' : 'p-8'}`}>
      <RemoveScrollBar />
      <div
        className='aspect-video h-[90%]'
        role='presentation'
        onContextMenu={e => e.preventDefault()}
      >
        <h1 className='sr-only absolute'>Instructions video - How to Use Your Portal</h1>
        {renderVideo(currentVideoUrl, true)}
      </div>
    </div>
  )
}
